import { Injectable} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppGgProjectsListComponent } from '../../gg-gateway/components/gg-projects-list/gg-projects-list.component';
import { MatDialog } from '@angular/material/dialog';
import { GgAuthService } from '../../gg-gateway/services/gg-auth.service';
import { MemberModel } from '../../../models/user.model';
@Injectable({
    providedIn: 'root'
})
export class LayoutDataService {
  constructor(
    private dialog:MatDialog,
    private ggAuthService:GgAuthService,
  ){}
  public bSubToggleMenuPanel: BehaviorSubject<boolean> = new BehaviorSubject(false)
  public subGlobalSearch: Subject<string> = new Subject()
  
  selectCompany (userProfile:MemberModel){
    this.dialog.open(AppGgProjectsListComponent, {
        panelClass: 'padding-modalbox',
        height: '100%',
        maxHeight: '90vh'
    })
    userProfile ? this.ggAuthService.loginStateSub.next({
        state: 'select_project',
        userData: userProfile,
        projects: userProfile.projects_list
    }) : null;
  }
}